import { render, staticRenderFns } from "./PeerGroupDuplicateDialog.vue?vue&type=template&id=bc11ff8c&scoped=true&"
import script from "./PeerGroupDuplicateDialog.vue?vue&type=script&lang=ts&"
export * from "./PeerGroupDuplicateDialog.vue?vue&type=script&lang=ts&"
import style0 from "./PeerGroupDuplicateDialog.vue?vue&type=style&index=0&id=bc11ff8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc11ff8c",
  null
  
)

export default component.exports